import { fetcher } from 'services/helpers/responseHandler'

const getAnalytics = async () => {
  return fetcher.get('content/analytics')
}

const updateConfiguration = async (notificationContentId, configuration) => {
  return fetcher.put(`content/${notificationContentId}/configuration`, {
    messageTemplate: configuration.messageTemplate,
    isActive: configuration.isActive,
    medium: configuration.medium,
    hoursAfterPreviousCampaign: configuration.hoursAfterPreviousCampaign,
    messageMediaUrls: configuration.messageMedia ? [configuration.messageMedia] : []
  })
}

const getOtaBusterAnalytics = async ({ startDate, endDate } = {}) => {
  const params = new URLSearchParams()
  if (startDate) {
    params.set('startDate', startDate)
  }
  if (endDate) {
    params.set('endDate', endDate)
  }
  const query = params.toString()
  const url = query
    ? `content/notification/ota-buster/analytics?${query}`
    : 'content/notification/ota-buster/analytics'
  return fetcher.get(url)
}

const getOtaBusterManage = async () => {
  return fetcher.get('content/notification/ota-buster/manage')
}

const saveOtaBusterStepDraft = async (notificationContentId, draft) => {
  return fetcher.put(`content/notification/ota-buster/steps/${notificationContentId}/draft`, draft)
}

const launchOtaBusterCampaign = async () => {
  return fetcher.post('content/notification/ota-buster/launch')
}

const pauseOtaBusterCampaign = async () => {
  return fetcher.post('content/notification/ota-buster/pause')
}

const resumeOtaBusterCampaign = async () => {
  return fetcher.post('content/notification/ota-buster/resume')
}

const contentApi = {
  getAnalytics,
  getOtaBusterAnalytics,
  getOtaBusterManage,
  saveOtaBusterStepDraft,
  launchOtaBusterCampaign,
  pauseOtaBusterCampaign,
  resumeOtaBusterCampaign,
  updateConfiguration
}

export default contentApi
